module.exports = __webpack_public_path__ + "static/eu-8680b3566ee646f3863a1f84dc9b0f6e.png";